module.exports = __webpack_public_path__ + "static/media/BD.62ab20ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BD.svg
// module id = 200
// module chunks = 0